<template>
    <cadastro-simples-form
        endpoint="orgao-regional"
        rota-base="/admin/orgao-regional"
        titulo-singular="Órgão Regional"
        :campos-extras='[{"campo":"sigla","label":"Sigla","tipo":"string","maxLength":20},{"campo":"codigo_inep","label":"Código INEP","tipo":"string","maxLength":20}]'>
    </cadastro-simples-form>
</template>

<script>
import CadastroSimplesForm from '@/components/cadastros-auxiliares/cadastro-simples-form.vue'
export default { components: { CadastroSimplesForm } }
</script>
